import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SalienteLibrarySharedModule } from '@saliente/library';
import { ReleaseNotesDialogComponent } from './release-notes-dialog.component';
import { ReleaseNotesDialogService } from './release-notes-dialog.service';

const COMPONENTS = [ReleaseNotesDialogComponent];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		SalienteLibrarySharedModule
	],
	declarations: [
		...COMPONENTS
	],
	exports: [
		...COMPONENTS
	],
	providers: [
		ReleaseNotesDialogService
	]
})
export class ReleaseNotesSharedModule {
}
